<template>
  <div class="POAPRULEPAGE" :class="theme==0?'dark':'white'">
    <div class="title">{{$t('poapRule.title')}}</div>
    <div class="info">
      <p>{{$t('poapRule.text1')}}</p>
      <p>{{$t('poapRule.text2')}}</p>
      <p>{{$t('poapRule.text3')}}</p>
      <p>{{$t('poapRule.text4')}}</p>
      <p>{{$t('poapRule.text5')}}</p>
      <p>{{$t('poapRule.text6')}}</p>
      <p>{{$t('poapRule.text7')}}</p>
      <p>{{$t('poapRule.text8')}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }

  }

</script>

<style scoped lang="less">
  .POAPRULEPAGE {
    position: fixed;
    padding: 0 15px;

    .back {
      position: absolute;
      left: 15px;
      top: 23px;
      width: 21px;
      height: 9px;

      img {
        width: 21px;
        height: 9px;
      }
    }

    .title {
      margin-top: 63px;
      font-size: 17px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      margin-bottom: 17px;
    }

    .info {
      p {
        margin: 0 0 5px;
        padding: 0;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #FFFFFF;
        line-height: 19px;

      }
    }
  }

  .dark {
    background: #000000 !important;

    .title {
      color: #FFFFFF;
    }

    .info {
      p {
        color: #FFFFFF;
      }
    }
  }

  .white {
    background: #ffffff !important;

    .title {
      color: #333333;
    }

    .info {
      p {
        color: #333333;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/poap/poapRule.vue